import Modal from '@web-ui-kit/modal'
import Text from '@web-ui-kit/text'
import * as Sc from '../Modals.styles'

import { useGlobalModalContext } from 'contexts/GlobalModalContext'
import i18n from 'i18n'
import { useWindowDimensions } from 'hooks'
import { isMobile } from 'utils/rebrandingUtils'

const UnsavedChangesModal = () => {
  const { store, hideModal } = useGlobalModalContext()
  const { modalProps } = store || {}
  const { onCancel, onConfirm, isOpenActivity } = modalProps || {}

  const handleCancel = () => {
    if (onCancel) onCancel()

    hideModal()
  }

  const handleConfirm = () => {
    if (onConfirm) onConfirm()

    hideModal()
  }

  const handleClose = () => {
    hideModal()
  }

  const { width: windowWidth } = useWindowDimensions()

  const text = isOpenActivity ? (
    <>
      {i18n.t('Aún no has acabado la actividad.')}
      <br />
      {i18n.t('Puedes guardar como borrador tu respuesta o salir sin guardar.')}
    </>
  ) : (
    <>{i18n.t('Si abandonas la actividad, perderás todo lo que has hecho.')}</>
  )

  const onCancelText = isOpenActivity ? i18n.t('Descartar y Salir') : i18n.t('Seguir editando')
  const onConfirmText = isOpenActivity ? i18n.t('Guardar y Salir') : i18n.t('Salir')

  return (
    <Modal
      buttons={{
        contained: {
          disabled: false,
          label: onConfirmText,
          onClick: handleConfirm,
        },
        outlined: {
          disabled: false,
          label: onCancelText,
          onClick: handleCancel,
        },
      }}
      contentTitle={i18n.t('¿Seguro que quieres salir?')}
      handleCloseModal={handleClose}
      id={'unsaved-changes-modal'}
      isSmall={isMobile(windowWidth)}
      topNav={{
        enableCloseIcon: true,
        title: i18n.t('Abandonar actividad'),
      }}
    >
      <Sc.ModalActivityContainer isFullscreen={isMobile(windowWidth)}>
        <Text component='span' variant='body'>
          {text}
        </Text>
      </Sc.ModalActivityContainer>
    </Modal>
  )
}

export default UnsavedChangesModal
